import React, { useEffect, useMemo, useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom'

import sortBooks from '../../components/Books/SortBooks';
import SearchResult from "../../components/Books/SearchResult";
import Loader from '../../components/Loader';
import Pagination from '../../components/Pagination';
import NotFound from "../../components/NotFound";
import MostSearch from "../../components/Books/MostSearch";

import { useAdvancedSearch } from '../../hooks/Hooks';

function AdvancedSearch() {
    document.title = 'Recherche avancée - Suplib';
    const [query, setQuery] = useState('');
    const [author, setAuthor] = useState('');
    const [date, setDate] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({ query: '', author: '', date: '', page: 1 });
    const { results, isLoading } = useAdvancedSearch(search.query, search.author, search.date, search.page);
    const itemsPerPage = 9;
    // eslint-disable-next-line no-unused-vars
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortType, setSortType] = useState('AZ');
    const navigate = useNavigate();
    const location = useLocation();

    const booksWithCover = useMemo(() => results ? results.filter(book => book.cover_i) : [], [results]);

    useEffect(() => {
        setTotalPages(Math.ceil(booksWithCover.length / itemsPerPage));
    }, [booksWithCover]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const queryParam = params.get('q');
        if (queryParam) {
            setQuery(queryParam);
            setSearch({ query: queryParam, author, date, page: 1 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPage(1);
        setSearch({ query, author, date, page: 1 });
        navigate(`/recherche-avancee?q=${query}`);
    };

    const handleSortChange = (event) => {
        setSortType(event.target.value);
    };

    const sortedResults = sortBooks(booksWithCover, sortType);

    return (
        <>
            <h2 className="text-2xl font-extrabold mt-10 mb-10 text-center">Recherche avancée</h2>

            <div className="container mx-auto px-4">
                <form className="mx-auto" onSubmit={handleSearchSubmit}>
                    <label htmlFor="default-search" className="mb-2 text-sm font-medium sr-only">Recherche avancée</label>
                    <div className="flex flex-wrap gap-4 flex-col sm:flex-row">
                        <div className="flex-1 mb-4 sm:mb-0 relative">
                            <input type="search" id="default-search" className="input-text block w-full p-4 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="Titre" value={query} onChange={(e) => setQuery(e.target.value)} required />
                            <button type="submit" className="absolute end-2.5 bottom-2.5 text-white bg-blue-900 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2">
                                Rechercher
                            </button>
                        </div>
                        <div className="flex-1 mb-4 sm:mb-0">
                            <input type="text" id="author-search" className="input-text block w-full p-4 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="Auteur" value={author} onChange={(e) => setAuthor(e.target.value)} />
                        </div>
                        <div className="flex-1">
                            <input type="text" id="date-search" className="input-text block w-full p-4 text-sm border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="Date" value={date} onChange={(e) => setDate(e.target.value)} />
                        </div>
                    </div>
                </form>

                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        {search.query === '' && !isLoading ? (
                            <div className="mt-10">
                                <MostSearch />
                            </div>
                        ) : booksWithCover.length > 0 ? (
                            <>
                                <h3 className="text-2xl font-extrabold mt-10 text-center">Résultat de la recherche pour : "{search.query}"</h3>

                                <form className="max-w-sm mx-auto mt-10">
                                    <label htmlFor="underline_select" className="sr-only">Sélectionnez une option</label>
                                    <select onChange={handleSortChange} id="underline_select" className="block py-2.5 px-0 w-full text-sm bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 peer">
                                        <option value="">Sélectionnez une option de tri</option>
                                        <option value="AZ">Trier de A à Z</option>
                                        <option value="ZA">Trier de Z à A</option>
                                        <option value="LowToHighRate">Moins bien noté au mieux noté</option>
                                        <option value="HighToLowRate">Mieux noté au bien moins noté</option>
                                    </select>
                                </form>

                                <div className="flex flex-col sm:flex-row items-center justify-center mt-10">
                                    <SearchResult results={sortedResults.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage )}/>
                                </div>

                                <Pagination page={currentPage} totalPages={Math.ceil(booksWithCover.length / itemsPerPage)} setPage={setCurrentPage} />
                            </>
                        ) : (
                            <NotFound query={search.query} />
                        )}
                    </>
                )}
            </div>
        </>
    );
}

export default AdvancedSearch;